import React from "react";
import Card from "../../components/generics/Card";

const TailoredOverview = props => (
  <Card message="No data found" style={{height:"100%",borderRadius: "12px 12px 0 0"}} messageIcon="tools"/>
);

export default TailoredOverview;
